export function getConnections(location) {
  return (location?.connections || []).map(c =>
    typeof c === 'string' ? { id: c, ttt: 10 } : c
  );
}

export function getConnectionTTT(location, targetId) {
  const conn = getConnections(location).find(c => c.id === targetId);
  return conn?.ttt ?? 10;
}

// BFS — returns first neighbor of `from` on shortest path to `to`
export function nextStep(locations, from, to) {
  if (from === to) return null;
  const visited = new Set([from]);
  const queue = [[from, null]];
  while (queue.length) {
    const [current, firstStep] = queue.shift();
    for (const { id } of getConnections(locations[current])) {
      if (!visited.has(id)) {
        const step = firstStep ?? id;
        if (id === to) return step;
        visited.add(id);
        queue.push([id, step]);
      }
    }
  }
  return null;
}

// BFS — returns full path array from `from` to `to`, or null if unreachable
export function findPath(locations, from, to) {
  if (from === to) return [from];
  const visited = new Set([from]);
  const queue = [[from, [from]]];
  while (queue.length) {
    const [current, path] = queue.shift();
    for (const { id } of getConnections(locations[current])) {
      if (!visited.has(id)) {
        const newPath = [...path, id];
        if (id === to) return newPath;
        visited.add(id);
        queue.push([id, newPath]);
      }
    }
  }
  return null;
}
